export const userRoles = {
    USER: 'ROLE_USER',
    MANAGER: 'ROLE_MANAGER',
    TEACHER: 'ROLE_TEACHER',
};

export const administrativePositions = {
    TEACHER: 'TEACHER',
    SECRETARY: 'SECRETARY',
    HEAD_OF_DEPARTMENT: 'HEAD_OF_DEPARTMENT',
};

/**
 * Administrative posts that may manage their own department's curriculum.
 * Mirrors DepartmentAccessGuard.CURRICULUM_EDITORS on the server, which is what actually decides.
 */
export const curriculumEditorPositions = [
    administrativePositions.SECRETARY,
    administrativePositions.HEAD_OF_DEPARTMENT,
];

/**
 * Whether the user may reach the curriculum pages at all. Which groups they may then change is
 * the server's decision — this only keeps the menus and routes honest.
 */
export const canEditCurriculum = (role, administrativePosition) =>
    role === userRoles.MANAGER || curriculumEditorPositions.includes(administrativePosition);
